import { styled } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useSelector } from "react-redux";
import { getGraphWidth } from "../../redux/selectors/chartSelector";
import {
  mobileBreakpoint,
  useWindowWidthAndHeight,
} from "../../shared/hooks/customHooks";
import "./tableComponentStyle.css";
export type DataTable = {
  key: string;
  columns: CellData[];
};
export type CellData = {
  data: string;
  component?: "th" | "td";
  className?: string[];
};

export type Props = {
  titles: string[];
  data: DataTable[];
  unit: string;
  caption: string;
};

const TableComponent: React.FC<Props> = ({ titles, data, unit, caption }) => {
  const width = useSelector(getGraphWidth);
  const [windowWidth] = useWindowWidthAndHeight();

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    "&": {
      padding: windowWidth > mobileBreakpoint ? "16px" : "8px",
    },
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#286AC7",
      color: theme.palette.common.white,
      // Pour une raison obscure, on a beau essayer de forcer comme on peut la position sticky
      // l'entête ne colle jamais le haut de son conteneur ou de l'écran
      // position: "sticky",
      // top: 0,
      // left: 0,
      // right: 0
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  return (
    <div
      className="table-container"
      style={{
        display: "flex",
        flexFlow: "column",
        height: "400px",
        flexGrow: 1,
        overflow: "auto",
      }}
    >
      <h6 style={{ alignSelf: "flex-end" }}>{unit}</h6>
      <TableContainer component={Paper} sx={{ maxHeight: "max-content" }}>
        <Table stickyHeader={true} sx={{ minWidth: width / 2 }}>
          <caption>{caption}</caption>
          <TableHead>
            <TableRow>
              {titles.map((title) => (
                <StyledTableCell scope="col" key={"unique" + title} align="center">
                  {title}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <StyledTableRow itemScope={true} key={row.key}>
                {row.columns.map((col, i) => (
                  <StyledTableCell
                    key={`${row.key}-${i}`}
                    align="center"
                    component={col.component || "td"}
                    scope="row"
                    className={col.className?.join(" ")}
                  >
                    {col.data}
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default TableComponent;
